import React from 'react'

//styles
import "./Galeria.css"
import { MOCK_PRODUCTS } from '../../MOCK/test-products'
import { Product as ModelProduct } from '../../Models/Product'
import Product from '../../Components/Product/Product'

const Galeria = () => {
  return (
    <div className='layout-page galeria-page'>

      <div className='galeria-header'>

        <div className='galeria-header-text'>
          <h2>PROTECCIÓN DE NIVEL MUSEO, EVOLUCIONADA.</h2>
          <span>Accede a un adelanto exclusivo de la nueva generación de accesorios Card Armory. Diseñados para jugadores competitivos y coleccionistas exigentes que buscan la máxima seguridad para sus cartas.</span>
        </div>

        <div className='galeria-header-logo-desk'>
            <img src='/isologo.png'></img>
        </div>

        <div className='galeria-header-logo'>
          <img src='/isologo.png'></img>
        </div>
      </div>

      <div className='galeria-products'>
        {MOCK_PRODUCTS.map((p:ModelProduct, index)=>{
          return <Product product={p} key={"producto "+ p.id} delay={index} />
        })}
      </div>


    </div>
  )
}

export default Galeria